import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import { ColumnWithScrollbar, FlexColumn, PrimaryColorDivider, SpaceBetweenRowContainer } from '../styles/Containers'
import { BoldFormTitle } from '../styles/Text'
import ActivityLogList from './ActivityLogList'
import NewActivityButton from './NewActivityButton'

// NOTE: 452px in max-height is the addition of the status container, due date
// container (with only one due date), the activity log header/button and padding,
// and the gap/padding on the FOIResponsePage sticky column. Update this calc if
// we add additional things to the Due Dates/status containers.
const ActivitiesContainer = styled(ColumnWithScrollbar)`
  max-height: calc(100vh - 452px);
  min-height: 100px;
`

function ActivityLog({ foiId, activityList, users = [], onUpdateActivities = () => {} }) {
  const [activities, setActivities] = useState(activityList)

  useEffect(() => {
    setActivities(activityList)
  }, [activityList])

  function addNewActivity(newActivity) {
    const updatedActivities = [...activities, newActivity]
    setActivities(updatedActivities)
    onUpdateActivities(updatedActivities)
  }

  function handleUpdatingActivity(updatedActivity) {
    const updatedActivities = activities.map(a => (a.id === updatedActivity.id ? updatedActivity : a))
    setActivities(updatedActivities)
    onUpdateActivities(updatedActivities)
  }

  return (
    <FlexColumn gap="15px">
      <SpaceBetweenRowContainer>
        <BoldFormTitle>Activity Log</BoldFormTitle>
        <NewActivityButton foiId={foiId} onSuccess={addNewActivity} />
      </SpaceBetweenRowContainer>
      <PrimaryColorDivider />
      <ActivitiesContainer>
        <ActivityLogList activityList={activities} users={users} onUpdateActivity={handleUpdatingActivity} />
      </ActivitiesContainer>
    </FlexColumn>
  )
}

ActivityLog.propTypes = {
  foiId: PropTypes.string.isRequired,
  activityList: PropTypes.array.isRequired,
  users: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      firstName: PropTypes.string.isRequired,
      lastName: PropTypes.string.isRequired,
      chipColor: PropTypes.string
    })
  ),
  onUpdateActivities: PropTypes.func
}

export default ActivityLog
